import React, { useState, useEffect } from 'react';
import './LivePriceBar.css';

export default function LivePriceBar() {
  const [prices, setPrices] = useState({ gold: null, silver: null });

  const fetchPrices = async () => {
    try {
      const res = await fetch('/api/live-prices');
      if (!res.ok) return;
      const data = await res.json();
      setPrices(data);
    } catch {
      // silent
    }
  };

  useEffect(() => {
    fetchPrices();
    const interval = setInterval(fetchPrices, 60000); // refresh every 60s
    return () => clearInterval(interval);
  }, []);

  const formatTime = (ts) => {
    if (!ts) return '';
    const d = new Date(ts);
    return d.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' });
  };

  if (!prices.gold && !prices.silver) return null;

  return (
    <div className="live-price-bar">
      <div className="live-price-inner">
        <span className="live-dot" />
        <span className="live-label">Live Rates</span>
        {prices.gold && (
          <span className="live-item gold">
            Gold: ₹{Math.round(Number(prices.gold.price_per_gram)).toLocaleString('en-IN')}/g
            <small>{formatTime(prices.gold.fetched_at)}</small>
          </span>
        )}
        {prices.silver && (
          <span className="live-item silver">
            Silver: ₹{Math.round(Number(prices.silver.price_per_gram)).toLocaleString('en-IN')}/g
            <small>{formatTime(prices.silver.fetched_at)}</small>
          </span>
        )}
      </div>
    </div>
  );
}
